// --------------------------------------------------------------
// Created On: 2025-04-24
// Author: Zachary Thomas
//
// Last Modified: 2025-05-30
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Given a single series check if it is the job of the specific series to draw a possibly shared y-axis.
export default function getSeriesWillDrawYAxis(
  seriesIndex: number,
  seriesUnitName: string,
  seriesUnitMap: SeriesUnitMap,
  axisMode: AxisMode
): boolean {
  switch (axisMode) {
    case "Y_AXIS_ATTRIBUTE":
      return true;
    case "Y_AXIS_UOM": {
      let thisSeriesDrawsAxis = true;
      if (seriesUnitName in seriesUnitMap) {
        if (seriesIndex in seriesUnitMap[seriesUnitName]) {
          thisSeriesDrawsAxis = seriesUnitMap[seriesUnitName][seriesIndex].thisSeriesDrawsAxis;
        }
      }
      return thisSeriesDrawsAxis;
    }
    default:
      return false;
  }
}

interface SeriesUnitMap {
  [key: string]: {
    // The dynamic key is the unit name.
    [key: string]: {
      // The dynamic key is the series index number.
      thisSeriesDrawsAxis: boolean; // Whether this specific series is generating the y-axis.
    };
  };
}

type AxisMode = "Y_AXIS_ATTRIBUTE" | "Y_AXIS_UOM";
